export default {
  fire() {
    $('.cellar-types-item').on('click', function () {
      $('.cellar-types-item').removeClass('active');
      $(this).addClass('active');
      $('.cellar-fields-group').removeClass('in');
      $('.cellar-fields-group' + $(this).data('target')).addClass('in');
    });


    window.cellarSearch = function (type, base) {
      var types = { wine: 'vinho', sparkling: 'espumante' };
      var routes = {
        wine: ['line', 'country', 'region'],
        sparkling: ['type', 'country', 'alcohol'],
      };

      var route = types[type];
      for (var key in routes[type]) {
        var value = $('[name="'+type+'['+routes[type][key]+']"]').val();

        if (value) {
          route += '-' + value;
        }
      }

      window.location.href = base + route;
    };
  },
};



// WEBPACK FOOTER //
// ./scripts/components/cellar.js